import React from 'react';

import { FeatureExplanationPetBlock } from '@models/feature-explanation';
import { ColoredExplanationBlock } from './ColoredExplanationBlock';

export const PetExplanationBlock: React.FC<
  FeatureExplanationPetBlock
> = block => (
  <ColoredExplanationBlock block={block}>
    {block.stringRepresentation}
  </ColoredExplanationBlock>
);
